@for (designation of designations(); track $index) {
  @if (designation.relation) {
    <span class="chip chip-relation">{{ relationLabels[designation.relation] }}</span>
  } @else if (designation.role) {
    <span class="chip chip-profile">
      {{ roleLabel(designation.role) }}
      @if (designation.scope) {
        <span class="scope">· {{ scopeLabels[designation.scope] }}</span>
      }
    </span>
  }
} @empty {
  <span class="chip chip-empty"
    ><svg lucideTriangleAlert aria-hidden="true"></svg>{{ emptyLabel() }}</span
  >
}
